var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 127,
    height: 24.596,
    viewBox: "0 0 127 24.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#161615;}.b{fill:#0090df;}.c{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-170 -243)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(170 243)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M422.4,180.163h-7.853v4.229h5.146v20.226h5.389V184.392h5.171v-4.229H422.4",
    transform: "translate(-303.25 -180.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M379.622,185.1l1.958-.726-.024,20.178,5.34.048V183.288c-.217-2.03-1.426-3.118-3.673-3.263a5.7,5.7,0,0,0-1.3.073l-2.3,1.015-1.522.652v-1.74h-5.751v24.528h5.485V185.777Z",
    transform: "translate(-277.633 -180.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M339.327,204.484h6.259V200.23h-7.129v-5.364h7.129v-4.277h-7.129v-6.211h7.129V180.1H333.044v24.383Z",
    transform: "translate(-253.769 -180.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M301.266,184.392h2.562v-4.229H288.146v4.229h5.123v20.226h5.388V184.392Z",
    transform: "translate(-226.51 -180.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M256.58,180.009h-6.911c-2.658-.193-3.818,1.04-3.963,3.239v21.289h5.509v-8.409l1.764-.677,1.957-.724-.024,9.81,5.365.048V183.272C260.035,181.241,258.827,180.154,256.58,180.009Zm-1.667,10.125-1.933.677-1.643.6v-7.345h3.576Z",
    transform: "translate(-200.743 -179.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M212.541,180.039H201.666v24.527h5.51v-8.409l1.788-.677,7.274-2.755V183.3Q215.911,180.257,212.541,180.039Zm-1.813,10.125-1.765.628-1.788.653V184.1h3.552Z",
    transform: "translate(-174.005 -180.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M131.258,179.989v24.6h24.6V187.349l-7.36-7.36Z",
    transform: "translate(-131.258 -179.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184.688,185.926l-5.937-5.937h5.937Z",
    transform: "translate(-160.092 -179.989)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.29 6.399)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M148.687,204.7l1.27-8.418h2.592v11.857h-1.762v-8.5l-1.287,8.5h-1.762l-1.389-8.384v8.384h-1.626V196.278h2.591Z",
    transform: "translate(-144.723 -196.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M168.9,204.2l-2.354-7.927H168.5l1.423,5.4,1.423-5.4h1.779l-2.355,7.927v3.93H168.9Z",
    transform: "translate(-157.975 -196.278)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c7832ac1dd3e7173d91b3932d493dcab.svg";
export { ForwardRef as ReactComponent };